import { z } from 'zod';
import { amountMinorSchema, isoTimestampSchema, uuidSchema } from './common';
import { salesChannelSchema } from './orders';

export const priceListLineSchema = z.object({
  id: uuidSchema,
  menu_item_id: uuidSchema,
  item_name: z.string(),
  channel: salesChannelSchema,
  price_minor: amountMinorSchema,
});

export const priceListVersionSchema = z.object({
  id: uuidSchema,
  version_no: z.number().int().positive(),
  name: z.string(),
  status: z.enum(['draft', 'submitted', 'scheduled', 'active', 'retired', 'rejected', 'failed']),
  effective_at: isoTimestampSchema,
  supersedes_id: uuidSchema.nullable(),
  created_by: uuidSchema.nullable(),
  submitted_at: isoTimestampSchema.nullable(),
  approved_by: uuidSchema.nullable(),
  approved_at: isoTimestampSchema.nullable(),
  published_at: isoTimestampSchema.nullable(),
  rejection_reason: z.string().nullable(),
  failure_reason: z.string().nullable(),
  version: z.number().int(),
  created_at: isoTimestampSchema,
  lines: z.array(priceListLineSchema),
});
export type PriceListVersion = z.infer<typeof priceListVersionSchema>;
export const priceListVersionListSchema = z.object({ items: z.array(priceListVersionSchema) });

const inputLine = z.object({
  menu_item_id: uuidSchema,
  channel: salesChannelSchema,
  price_minor: amountMinorSchema.refine((value) => value >= 0),
});
export const createPriceListVersionRequestSchema = z.object({
  name: z.string().trim().min(3).max(120),
  effective_at: isoTimestampSchema,
  lines: z.array(inputLine).min(1).max(2_000),
});
export const updatePriceListVersionRequestSchema = createPriceListVersionRequestSchema.extend({
  expected_version: z.number().int().nonnegative(),
});
export const priceListActionRequestSchema = z.object({
  expected_version: z.number().int().nonnegative(),
});
export const rejectPriceListVersionRequestSchema = priceListActionRequestSchema.extend({
  reason: z.string().trim().min(3).max(500),
});
export const rollbackPriceListRequestSchema = z.object({
  source_version_id: uuidSchema,
  effective_at: isoTimestampSchema,
  name: z.string().trim().min(3).max(120),
});

export const effectivePriceSchema = z.object({
  menu_item_id: uuidSchema,
  channel: salesChannelSchema,
  price_minor: amountMinorSchema,
  price_list_version_id: uuidSchema.nullable(),
  effective_at: isoTimestampSchema.nullable(),
  fallback: z.boolean(),
});
export const effectivePriceListSchema = z.object({ items: z.array(effectivePriceSchema) });
